import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateStokeHQCodelist(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateStokeHQCodelist({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('StokeApi.getStokeHQCodelist', id)
          .then((json) => {
            // console.log(`zxy----getStokeHQCodelist---${JSON.stringify(json)}`);
            commit('updateStokeHQCodelist', {
              id,
              data: json.data,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
